import { Center, Flex, Stack, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { builder } from "@/builders";
import { useFakeAdminDashboardData } from "@/builders/types/admin-dashboard";
import { useCurrentORG } from "@/components/super-admin/org-management/use-organisation";
import { UserMetricIcon } from "@/svgs/user-metric-icon";

import clsx from "clsx";

export function ActiveUsers() {
  const initialDashboardData = useFakeAdminDashboardData();
  const { organization } = useCurrentORG();

  const { data, isPlaceholderData } = useQuery({
    queryKey: builder.data.admin_dashboard.$get({
      organization: organization.id,
    }),
    queryFn: () =>
      builder.$use.data.admin_dashboard({
        organization: organization.id,
      }),
    placeholderData: {
      data: initialDashboardData,
    },
    select: ({ data }) => data,
  });

  return (
    <Stack
      flex={1}
      className="rounded-lg border border-primary-border-light backdrop-blur-[50px]"
      p={16}
    >
      <Stack gap={4}>
        <Title
          order={2}
          className={clsx("text-white/50 prose-base/medium", {
            skeleton: isPlaceholderData,
          })}
        >
          Total Active Users
        </Title>

        <Flex justify="space-between" align="center" gap={16}>
          <Title
            order={1}
            fz={60}
            className={clsx("text-primary-background-white", {
              skeleton: isPlaceholderData,
            })}
          >
            {data?.total_active_users}
          </Title>
          <Center
            p={12}
            className={clsx(
              "border rounded-full h-fit border-white/50 bg-gradient-shadow",
              {
                skeleton: isPlaceholderData,
              }
            )}
          >
            <UserMetricIcon />
          </Center>
        </Flex>
      </Stack>
    </Stack>
  );
}
